import { ref, set, serverTimestamp } from 'firebase/database';
import { database } from '../config/firebase';

interface TrackingData {
  userId?: string;
  sessionId?: string;
  timestamp: number;
  userAgent: string;
  platform: string;
  ip?: string;
}

export const trackPageView = async (page: string, data?: Partial<TrackingData>) => {
  try {
    const pageViewRef = ref(database, `analytics/pageViews/${Date.now()}`);
    
    await set(pageViewRef, {
      page,
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      ...data
    }).catch((error) => {
      // Tracking must never break the page; surface the failure in the console.
      console.debug('Page view tracking failed (possibly blocked):', error);
    });
  } catch (error) {
    console.debug('Page view tracking error (possibly blocked):', error);
  }
};

export const trackUserInteraction = async (
  action: string,
  type: string,
  value: string
) => {
  try {
    const sanitizedAction = String(action || '').trim();
    const sanitizedType = String(type || '').trim();
    const sanitizedValue = String(value || '').trim();

    if (!sanitizedAction || !sanitizedType || !sanitizedValue) {
      return;
    }

    const interactionRef = ref(database, `analytics/interactions/${Date.now()}`);
    
    await set(interactionRef, {
      action: sanitizedAction,
      type: sanitizedType,
      value: sanitizedValue,
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent,
      platform: navigator.platform
    }).catch((error) => {
      // Tracking must never break the page; surface the failure in the console.
      console.debug('Interaction tracking failed (possibly blocked):', error);
    });
  } catch (error) {
    console.debug('Interaction tracking error (possibly blocked):', error);
  }
};